import { styled, DialogActions } from "@mui/material";
export const StyledDialogActions = styled(DialogActions)({
  justifyContent: "space-between",
  // paddingBottom: "5px",
});
